// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"189":"f96a6c6e","323":"f96a6c6e"}[chunkId] + ".chunk.css";
};